import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full flex flex-wrap" }
const _hoisted_3 = { class: "w-7/12 pr-2" }
const _hoisted_4 = { class: "w-3/12 pr-2" }
const _hoisted_5 = { class: "w-1/12" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pesquisar ")
const _hoisted_7 = { class: "w-1/12 pl-2" }
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = {
  key: 0,
  class: "w-full grid place-content-center min-h-screen"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_SearchOutline = _resolveComponent("SearchOutline")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_ModalAdicionarSubgrupo = _resolveComponent("ModalAdicionarSubgrupo")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_n_select, {
          value: _ctx.formRef.id_grupo,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formRef.id_grupo) = $event)),
          options: _ctx.gruposOptions,
          placeholder: "Grupo",
          class: "w-full",
          filterable: "",
          clearable: ""
        }, null, 8, ["value", "options"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_n_input, {
          class: "w-full",
          value: _ctx.formRef.search,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formRef.search) = $event)),
          type: "text",
          placeholder: "Titulo"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_n_button, {
          type: "info",
          class: "w-full",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_SearchOutline)
          ]),
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ModalAdicionarSubgrupo, {
          emitUpdate: () => _ctx.subgrupos.fetch()
        }, null, 8, ["emitUpdate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.subgrupos.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
        : (_openBlock(), _createBlock(_component_n_data_table, {
            key: 1,
            remote: "",
            ref: "table",
            columns: _ctx.columns,
            data: (_ctx.subgrupos.data as any),
            loading: _ctx.subgrupos.isLoading,
            pagination: _ctx.subgrupos.pagination,
            "onUpdate:page": _ctx.subgrupos.handlePageChange,
            "onUpdate:pageSize": _ctx.subgrupos.handlePageSizeChange
          }, null, 8, ["columns", "data", "loading", "pagination", "onUpdate:page", "onUpdate:pageSize"]))
    ])
  ]))
}